import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { baseComponents } from '~components/markdown';
import { useMeta } from '~store/meta';
import { ButtonGroup, Container, Icon, IconButton, Stack } from '@chakra-ui/react';
import { FaGithub, FaLinkedin, FaTwitter } from 'react-icons/fa';
import ReactMarkdown from 'react-markdown';
var Footer = function() {
    var ref, ref1;
    var meta = useMeta();
    var content = "\nContents licensed under [CC BY-NC-SA 4.0](https://creativecommons.org/licenses/by-nc-sa/4.0/).  \nMade using [Next.js](https://nextjs.org), [Chakra UI](https://chakra-ui.com),\nand [DatoCMS](https://www.datocms.com). Hosted on [Vercel](https://vercel.com).\nInspired from [Griko](https://griko.id).\n\nMIT License &copy; ".concat(new Date().getFullYear(), "&ndash;present\n[").concat((ref = meta.site.seo) === null || ref === void 0 ? void 0 : ref.siteName, "](.).");
    var ref2 = (ref1 = meta.about) === null || ref1 === void 0 ? void 0 : ref1.socials, GitHub = ref2.GitHub, LinkedIn = ref2.LinkedIn, Twitter = ref2.Twitter;
    return(/*#__PURE__*/ _jsx(Container, {
        as: "footer",
        color: "whiteAlpha.700",
        maxW: "4xl",
        p: [
            4,
            8
        ],
        children: /*#__PURE__*/ _jsxs(Stack, {
            align: "center",
            fontSize: "xs",
            spacing: 4,
            textAlign: "center",
            children: [
                /*#__PURE__*/ _jsx(ReactMarkdown, {
                    children: content.trim(),
                    components: baseComponents
                }),
                /*#__PURE__*/ _jsxs(ButtonGroup, {
                    children: [
                        /*#__PURE__*/ _jsx(IconButton, {
                            "aria-label": "Twitter",
                            as: "a",
                            href: Twitter,
                            icon: /*#__PURE__*/ _jsx(Icon, {
                                as: FaTwitter
                            }),
                            target: "_blank",
                            variant: "ghost"
                        }),
                        /*#__PURE__*/ _jsx(IconButton, {
                            "aria-label": "GitHub",
                            as: "a",
                            href: GitHub,
                            icon: /*#__PURE__*/ _jsx(Icon, {
                                as: FaGithub
                            }),
                            target: "_blank",
                            variant: "ghost"
                        }),
                        /*#__PURE__*/ _jsx(IconButton, {
                            "aria-label": "LinkedIn",
                            as: "a",
                            href: LinkedIn,
                            icon: /*#__PURE__*/ _jsx(Icon, {
                                as: FaLinkedin
                            }),
                            target: "_blank",
                            variant: "ghost"
                        })
                    ]
                })
            ]
        })
    }));
};
export default Footer;
